export default __webpack_public_path__ + "static/frame-002-1931a98af2bd2451df2eafa0b6eb1648.png";